export default class Query {
    constructor(arg = undefined) {
      if (arg != undefined) {
        const campi = this.setControlli();
        campi.forEach((c) => {
          this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
        });
      } else {
        const campi = this.setControlli();
        campi.forEach((c) => {
          this[c.nome] = c.default_val;
        });
      }
    }
  
    // Metodo per resettare tutte i campi
    reset() {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  
    setControlli() {
      const campi = [
        { nome: "formato", default_val: "" },
        { nome: "id_nodo", default_val: -1 },
        { nome: "id_nodo_temp", default_val: -1 },
        { nome: "id_nodo_query", default_val: -1 },
        { nome: "query", default_val: "" },
        { nome: "label", default_val: "" },
        { nome: "ordine", default_val: null },
        { nome: "predefinita", default_val: 0 },
        { nome: "result", default_val: null },
        { nome: "status_code", default_val: null },
        { nome: "titolo", default_val: null },
        { nome: "validita", default_val: 1 },
      ];
      return campi;
    }
  }